/*
 * Mobile sticky add-to-cart.
 *
 * Shows a slim bar once the real add-to-cart button has scrolled out of view,
 * and forwards taps to that button rather than submitting its own form — the
 * product form already owns variant, quantity and sold-out state.
 */
class LusheStickyAtc extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector(this.dataset.target);
    if (!this.target) return;

    this.button = this.querySelector('[data-satc-add]');
    this.priceEl = this.querySelector('[data-satc-price]');

    this.button.addEventListener('click', () => {
      // Re-query: the product form re-renders when a variant changes.
      const live = document.querySelector(this.dataset.target);
      if (live) live.click();
    });

    this.observer = new IntersectionObserver(
      ([entry]) => this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      { rootMargin: '0px 0px -20% 0px' }
    );
    this.observer.observe(this.target);

    // Mirror the live button's disabled state and the current price.
    this.mutations = new MutationObserver(() => this.sync());
    this.mutations.observe(this.target, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('variant:change', () => this.sync());
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.mutations?.disconnect();
  }

  toggle(show) {
    if (show) this.removeAttribute('hidden');
    else this.setAttribute('hidden', '');
  }

  sync() {
    const live = document.querySelector(this.dataset.target);
    if (!live) return;
    this.button.disabled = live.disabled;
    this.button.textContent = live.textContent.trim();

    const price = document.querySelector('.price__container .price-item--regular, .price-item--sale');
    if (price && this.priceEl) this.priceEl.textContent = price.textContent.trim();

    // Keep the chosen colour in step with the picker.
    const variantEl = this.querySelector('[data-satc-variant]');
    const checked = document.querySelector('.product-form__input input:checked, .product-form__input select');
    if (variantEl && checked) {
      const label = checked.value || checked.selectedOptions?.[0]?.value;
      if (label) variantEl.textContent = label;
    }
  }
}

customElements.define('lushe-sticky-atc', LusheStickyAtc);
